import { createReducer, ActionType, createAsyncAction } from "typesafe-actions";
import {
  GuidepostDto,
  ApplicationLogVisitRequest,
  ResultOfBoolean,
  DocumentationDto,
} from "Api/Api";

export type GuidepostState = {
  isLoading: boolean;
  guidepost: GuidepostDto | null;
  documentation: DocumentationDto | null;
};

export const getGuidepostAsync = createAsyncAction(
  "@auth/GET_GUIDEPOST_REQUEST",
  "@auth/GET_GUIDEPOST_SUCCESS",
  "@auth/GET_GUIDEPOST_FAILURE",
)<
  string,
  { guidepost: GuidepostDto; documentation: DocumentationDto },
  Error
>();

export const postGuidepostLogAppVisitAsync = createAsyncAction(
  "@auth/POST_GUIDEPOST_LOG_APP_VISIT_REQUEST",
  "@auth/POST_GUIDEPOST_LOG_APP_VISIT_SUCCESS",
  "@auth/POST_GUIDEPOST_LOG_APP_VISIT_FAILURE",
)<ApplicationLogVisitRequest, ResultOfBoolean, Error>();

export type GuidepostAction =
  | ActionType<typeof getGuidepostAsync>
  | ActionType<typeof postGuidepostLogAppVisitAsync>;

export const guidepostReducer = createReducer<GuidepostState, GuidepostAction>({
  guidepost: null,
  isLoading: false,
  documentation: null,
})
  .handleAction(getGuidepostAsync.request, state => {
    return { ...state, isLoading: true };
  })
  .handleAction(getGuidepostAsync.success, (state, action) => {
    return {
      ...state,
      isLoading: false,
      guidepost: action.payload.guidepost,
      documentation: action.payload.documentation,
    };
  })
  .handleAction(getGuidepostAsync.failure, state => {
    return {
      ...state,
    };
  })

  .handleAction(postGuidepostLogAppVisitAsync.request, state => {
    return {
      ...state,
    };
  })
  .handleAction(postGuidepostLogAppVisitAsync.success, state => {
    return {
      ...state,
    };
  })
  .handleAction(postGuidepostLogAppVisitAsync.failure, state => {
    return {
      ...state,
    };
  });
